import React from "react"
import styled, { css } from "styled-components"
import media from "../utils/media"
import BackgroundImage from "gatsby-background-image"

const fullscreen = css`
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
`

const halfscreen = css`
  height: 85vh;
  height: calc(var(--vh, 1vh) * 85);
`

const WINDOW = typeof window !== "undefined" ? window.innerWidth : "2000"

const BackgroundSection = ({ className, bg, children }) => {
  return (
    <BackgroundImage
      Tag="section"
      className={className}
      fluid={bg.childImageSharp.fluid}
      backgroundColor={`#ffffff`}
    >
      {children}
    </BackgroundImage>
  )
}

const BannerProvider = props => {
  return !props.bg || typeof props.bg === 'string'? 
  <Banner {...props}/>: 
  <StyledBackgroundSection {...props}/>
}

const StyledBackgroundSection = styled(props => (
  <BackgroundSection {...props} />
))`
  width: 100%;
  ${props => (props.fullscreen ? fullscreen : null)};
  ${props => (props.halfscreen ? halfscreen : null)};
  padding: ${props =>
    props.fullscreen || props.halfscreen ? "0" : "8rem 0 10rem 0"};
  box-shadow: ${props =>
    props.overlay ? "inset 0 0 0 2000px rgba(0, 0, 0, 0.3)" : "0"};
  display: flex;
  background-size: cover;
  background-position: top;
  position: relative;
  ${props =>
    props.overlay
      ? `box-shadow:inset 0 0 0 ${WINDOW}px rgba(0, 0, 0, 0.3)`
      : null}
  padding: ${props => (props.fullscreen ? `0` : `8rem 0 10rem 0`)};
  ${media.phone`
    padding: ${props => (props.fullscreen ? `0` : `6rem 0 8rem 0`)};
  `}
`

export const Banner = styled.div`
  width: 100%;
  ${props => (props.fullscreen ? fullscreen : null)};
  ${props => (props.halfscreen ? halfscreen : null)};
  background: rgb(255, 216, 0);
  padding: ${props =>
    props.fullscreen || props.halfscreen ? "0" : "8rem 0 10rem 0"};
  background: ${props =>
    props.bg
      ? `url(${props.bg}) no-repeat center center`
      : "linear-gradient(135deg,rgba(252, 180, 0, 1) 0%, rgba(249, 126, 0, 1) 100%)"};
  box-shadow: ${props =>
    props.overlay ? "inset 0 0 0 2000px rgba(0, 0, 0, 0.3)" : "0"};
  display: flex;
  background-size: cover;
  background-position: top;
  position: relative;
  ${props =>
    props.overlay
      ? `box-shadow:inset 0 0 0 ${WINDOW}px rgba(0, 0, 0, 0.3)`
      : null}
  padding: ${props => (props.fullscreen ? `0` : `8rem 0 10rem 0`)};
  ${media.phone`
    padding: ${props => (props.fullscreen ? `0` : `6rem 0 8rem 0`)};
  `}
`

export default BannerProvider
